export default {
  question1: {
    id: 'product_page_iphone17_question1',
    defaultMessage: 'When will the iPhone 17 actually be released?',
  },
  answer1: {
    id: 'product_page_iphone17_answer1',
    defaultMessage:
      'Apple typically unveils new iPhones every September, so expect the iPhone 17 early September 2025. But if you need a smartphone now, we\'ve got lots of great iPhones for up to 70% less than new. Just click "Browse iPhones," above.',
  },
  question2: {
    id: 'product_page_iphone17_question2',
    defaultMessage: 'How much will the iPhone 17 cost?',
  },
  answer2: {
    id: 'product_page_iphone17_answer2',
    defaultMessage:
      'Early rumors suggest a starting price of up to $1,000, with Pro models likely reaching $1,200 or more. (Because nothing says "innovation" like adding another zero to the price tag.) Or, you can get a fully refurbished and equally awesome iPhone 15 or 16 on Back Market right now for hundreds of dollars less.',
  },
  question3: {
    id: 'product_page_iphone17_question3',
    defaultMessage:
      'Should I wait for the iPhone 17 or buy a refurbished iPhone now?',
  },
  answer3: {
    id: 'product_page_iphone17_answer3',
    defaultMessage:
      'Ask yourself: "Do I actually need the iPhone 17, or do I just want it?" Most people upgrade their phones way more often than necessary. A refurbished iPhone 15 or 16 will save you $400 – $600 compared to a brand-new iPhone 17, and you probably won\'t notice the difference. Same great photos, same smooth performance, same freedom to doomscroll for hours.',
  },
  question4: {
    id: 'product_page_iphone17_question4',
    defaultMessage:
      'Should I trade in my phone now, or wait for the iPhone 17?',
  },
  answer4: {
    id: 'product_page_iphone17_answer4',
    defaultMessage:
      "Easy. Trade in now, before your phone's trade-in value takes a nosedive when the iPhone 17 is announced. Phone values typically drop 15 – 20% after new releases, so acting sooner means more money in your pocket. Use that trade-in cash to snag a refurbished iPhone that already does most of what the iPhone 17 can do.",
  },
  question5: {
    id: 'product_page_iphone17_question5',
    defaultMessage:
      'Will I be able to get a refurbished iPhone 17 on Back Market?',
  },
  answer5: {
    id: 'product_page_iphone17_answer5',
    defaultMessage:
      "Yes! People usually start trading in new phones 1 – 3 months after they launch (often with a serious case of buyer's remorse). If you're really patient, you'll find a refurbished iPhone 17 priced much lower than new by early 2026.",
  },
}
